import React from "react"

// Components
import "./style.css"

const LoadingBox = ({ text, size }) => {
    return (
        <div className={`search-loading-wrapper search-loading--${size ? size : "normal"}`}>
            <div className="search-loading button button--purple">
                { text }

                { /* Animerte dots */ }
                <span className="search-loading__dot"></span>
                <span className="search-loading__dot"></span>
                <span className="search-loading__dot"></span>
            </div>
        </div>
    )
}

export default LoadingBox



// WEBPACK FOOTER //
// ./src/components/LoadingBox/index.js